import { render, staticRenderFns } from "./mention-individual.vue?vue&type=template&id=6799fc70&scoped=true"
import script from "./mention-individual.vue?vue&type=script&lang=js"
export * from "./mention-individual.vue?vue&type=script&lang=js"
import style0 from "./mention-individual.vue?vue&type=style&index=0&id=6799fc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6799fc70",
  null
  
)

export default component.exports